module.exports = __webpack_public_path__ + "media/images/partner/media/dlf-ebf26cc135a7f778d9686b298f3832bb.png";